<template>
  <div
      v-acl.show="{permission: 'create', on: 'OneOffRequest'}">
    <el-button
        v-if="piiAuthorized"
        type="primary"
        class="nav-action"
        round
        style="padding: 10px 25px;"
        @click="openForm()">
      {{ $t('common.one_off') }}
    </el-button>

    <one-off-modal-form ref="one_off" />
    <one-off-flow
        v-if="oneOffFormVisible"
        :visible.sync="oneOffFormVisible" />
  </div>
</template>

<script>
import OneOffModalForm from "@/containers/CustomerRequest/OneOffModalForm";
import { createNamespacedHelpers } from "vuex";
import OneOffFlow from "../../containers/Customer/OrderWidget/OneOff/OneOffFlow.vue";
const { mapGetters: accountGetters } = createNamespacedHelpers("db/account");
const { mapGetters: sharedGetters } = createNamespacedHelpers("shared");

export default {
  name: "OneOffButton",
  components: {
    OneOffFlow,
    OneOffModalForm,
  },
  data() {
    return {
      oneOffFormVisible: false,
    };
  },
  computed: {
    ...accountGetters(["piiAuthorized"]),
    ...sharedGetters(["userHasPermission", "markets"]),
    newOneOffFlow() {
      return !!this.userHasPermission({
        permission: "newOneOffFlow",
        on: "NewUI",
      });
    },
  },
  methods: {
    openForm() {
      if (!this.newOneOffFlow) this.$refs.one_off.openForm();
      else {
        this.showNewOneOffFlow();
      }
    },
    showNewOneOffFlow() {
      this.oneOffFormVisible = true;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/newui/buttons.scss";

.new-ui__left-nav .nav-action.el-button--primary.is-round {
  @include nav-bar__button();
}
</style>
